"use strict";

exports.__esModule = true;
exports.getWidgetPositionProps = getWidgetPositionProps;
/**
 * Get position related properties for a widget.
 */
function getWidgetPositionProps(_ref) {
  var x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height;
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}